import React from "react";
import tw from "tailwind-styled-components";
import { Formik, Form, Field, useFormik } from "formik";
import Loading from "../Loading";
import { InputGroup, Label, SubmitBtn } from "../Styles/InputStyles";
import Model from "../Model";
import * as Yup from "yup";
import { toast } from "react-toastify";

const AddComments = ({
  AddCommentsMutate,
  AddCommentsLoading,
  setAddComments,
  selectedData,
}) => { 

  const validationSchema = Yup.object().shape({
    businessName: Yup.string().nullable(),
    remark: Yup.string().nullable(),
  });

  const SubmitHandler = (values) => {
    const payload = {
      id: selectedData?.id,
      businessName: values.businessName,
      remark: values.remark,
    };

    if (!payload.id) {
      toast.error("Invalid user");
      return;
    }

    AddCommentsMutate(payload);
    // setAddComments(false);
  };


  return (
    <Model width={`w-11/12 max-w-lg`} setOpenModel={setAddComments}>
      {AddCommentsLoading ? (
        <div className="w-full h-full">
          <Loading />
        </div>
      ) : (
        <Formik
           initialValues={{
            id: selectedData?.id || "",
            businessName: selectedData?.businessName || "",
            remark: selectedData?.remarks || "",
          }}
          validationSchema={validationSchema}
          onSubmit={SubmitHandler}
          enableReinitialize
        >
          {({ errors, touched }) => (
            <Form>
              <Wrapper>
                <Title>Add Remark</Title>

                <InputGroup>
                  <Label htmlFor="businessName">Business Name </Label>
                  <FieldWrapper>
                    <Field
                      type="text"
                      name="businessName"
                      id="businessName"
                      autoComplete="off"
                      as= {Input}
                    />
                    {touched.businessName && errors.businessName && (
                      <p className="text-rose-600 text-sm">
                        {errors.businessName}
                      </p>
                    )}
                  </FieldWrapper>
                </InputGroup>


                <InputGroup>
                  <Label htmlFor="remark">Remark</Label>
                  <FieldWrapper>
                    <Field
                      as={Textarea}
                      name="remark"
                      rows={5}
                      placeholder="Enter Remark"
                    />
                    {touched.remark && errors.remark && (
                      <ErrorText>{errors.remark}</ErrorText>
                    )}
                  </FieldWrapper>
                </InputGroup>

                <BtnWrapper>
                  <SubmitBtn type="submit">Add Remark</SubmitBtn>
                </BtnWrapper>
              </Wrapper>
            </Form>
          )}
        </Formik>
      )}
    </Model>
  );
};

const BtnWrapper = tw.div`w-full flex items-center justify-center space-x-4 mt-8`;
const Title = tw.h2`text-lg md:text-xl lg:text-2xl text-gray-600 font-medium mb-6 text-center`;
const Wrapper = tw.div`px-2 space-y-4`;
const FieldWrapper = tw.div`w-full`;
const Textarea = tw.textarea`min-h-30 border border-gray-300 rounded pl-2 py-2 focus:ring-1 focus:ring-sky-600 focus:border-sky-600 focus:outline-none duration-200 w-full resize-y`;
const ErrorText = tw.p`text-red-500 text-sm mt-1`;
const Input = tw.input`truncate border border-gray-300 border-m rounded pl-2 focus:ring-1 focus:ring-sky-600 focus:border-sky-600 focus:outline-none duration-200`;

export default AddComments;